module.exports = __webpack_public_path__ + "img/Winter-KV.1d118bc4.jpg";